__turbopack_context__.v({
  "className": "noto_serif_display_5820a7d9-module__1ara_W__className",
  "variable": "noto_serif_display_5820a7d9-module__1ara_W__variable",
});
